<div class="loader-contain" [hidden]="!loading">
  <div class="loader"></div>
</div>
